<template>
  <div>

    <h1 style="font-size: 24px; color: black;">广告配置</h1>
    <el-tabs type="card" v-model="selectedBusinessTypes" @tab-click="changeActivityTypeStyle" >
        <el-tab-pane v-for="item in  allBusinessTypes"  :name="item.id+'' " :key="item.id" :label="item.name">
        </el-tab-pane>
    </el-tabs>
    <div style="margin-bottom: 10px;">
      <table>
        <tr>
            <div style="margin-bottom: 10px;">
              <el-row>
                  <span > 用户类型： </span>
                  <el-select v-model="queryAdConfig.userType"    clearable   placeholder="请选择/输入">
                      <el-option
                          v-for="item in allUserTypes"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                  </el-select>
                  <span > 渠道选择： </span>
                    <el-cascader
                            v-model="queryAdConfig.subChannels"
                            :options="channelList"
                            :props="optionProps"
                            clearable
                            collapse-tags>
                    </el-cascader>
                  <span v-if="selectedBusinessTypes==1"> 矩阵位置： </span>
                  <el-select v-if="selectedBusinessTypes==1" v-model="queryAdConfig.positionType"   clearable collapse-tags placeholder="请选择/输入">
                      <el-option
                          v-for="position in allInnerPositionTypes"
                          :label="position.name"
                          :key="position.id"
                          :value="position.id">
                      </el-option>
                  </el-select>
                  &emsp;&emsp;&emsp;
                  <el-button  type="primary" style="margin-left:10px;" @click="searchListAdConfig">查询</el-button> 
                  &emsp;&emsp;&emsp; 
                  <el-button  type="primary" @click="editDialogFun(true,'新增广告配置')">新增广告配置</el-button> 
              </el-row>
            </div> 
        </tr>
      </table> 
    </div>
    <div>
      <el-table border :data="adConfigs">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column   label="绑定渠道" :width="300" prop="subChannels"  :show-overflow-tooltip="true" >
          </el-table-column>
          <el-table-column   label="素材ID" :width="200" v-if="selectedBusinessTypes==0"  :show-overflow-tooltip="true" >
              <template slot-scope="scope">
                  {{scope.row.materialIds.length ===0 ? '暂无':scope.row.materialIds.join(",")}}
              </template>
          </el-table-column>
        <el-table-column prop="positionNumber" label="位置编号"></el-table-column>
        <!-- <el-table-column prop="businessType" label="业务类型"  :formatter="businessTypeFormatter"> </el-table-column>  -->
        <el-table-column prop="positionType" v-if="selectedBusinessTypes==1" label="位置类型"  :formatter="positionTypeFormatter"> </el-table-column> 
        <el-table-column label="适用游戏范围"  v-if="selectedBusinessTypes==1" align="center" width="150px">
         <template slot-scope="scope">
                    <el-link   type="primary"   @click="showSelectorDialog(scope.row)"> 已选{{scope.row.count }}款 </el-link>
           </template>
        </el-table-column>
        <el-table-column prop="positionType" v-if="selectedBusinessTypes==2" label="位置类型"  :formatter="positionTypePartitionFormatter"> </el-table-column> 
        <el-table-column prop="positionType" v-if="selectedBusinessTypes==3" label="位置类型"  :formatter="positionTypeMyFormatter"> </el-table-column> 
        <!-- <el-table-column prop="positionType" v-if="selectedBusinessTypes==1" label="位置类型"  :formatter="positionTypeFormatter"> </el-table-column>  -->
        <el-table-column prop="userType" label="用户类型"  :formatter="userTypeFormatter"> </el-table-column> 
        <el-table-column prop="createDt" label="创建时间" :formatter="formatDate"></el-table-column>
        <el-table-column prop="updateDt" label="更新时间" :formatter="formatDate"></el-table-column>
        <el-table-column label="开关" align="center" width="150px">
         <template slot-scope="scope">
                    <el-switch v-model="scope.row.state"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="开启"
                               inactive-text="关闭"
                               @change="update(scope.row)">
                    </el-switch>
           </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right"  align="center">
          <template slot-scope="scope">
            <el-button plain   size="mini" type="success" @click="editDialogFun(true,'编辑',scope.row)">编辑</el-button> 
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="editDialog.title"  center :visible.sync="editDialog.show" width="70%" :data="adConfig">
      <el-form>
        <el-form-item :label-width="labelWidth"  label="名称："  >  
          <el-input style="width: 220px" type="text" maxlength="20" placeholder="不超过20个字符" v-model="adConfig.name"></el-input> 
        </el-form-item>
        <el-form-item :label-width="labelWidth"   v-if="editFlag==false"  label="业务类型："> 
            <el-select   v-model="adConfig.businessType" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in allBusinessTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
          <el-form-item :label-width="labelWidth" v-if="selectedBusinessTypes==0"  label="素材选择：">
              <el-select v-model="adConfig.materialIds"  multiple clearable placeholder="请选择/输入" >
                  <el-option
                          v-for="item in materials"
                          :key="item.id"
                          :label="item.materialName"
                          :value="item.id">
                  </el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="渠道选择 :" :label-width="labelWidth">
                        <el-cascader
                                v-model="adConfig.subChannels"
                                :options="channelList"
                                :props="optionProps"
                                clearable
                                collapse-tags>
                        </el-cascader>
          </el-form-item>
        <el-form-item :label-width="labelWidth"  v-if="adConfig.businessType==1"  label="位置类型：">
            <el-select v-model="adConfig.positionType" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in allInnerPositionTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
                <el-form-item :label-width="labelWidth"  v-if="adConfig.businessType==2"  label="位置类型2：">
            <el-select v-model="adConfig.positionType" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in allPartitionPositionTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
                <el-form-item :label-width="labelWidth"  v-if="adConfig.businessType==3"  label="位置类型3：">
            <el-select v-model="adConfig.positionType" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in allMyPositionTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
         <el-form-item :label-width="labelWidth" v-if="adConfig.businessType==0 || adConfig.businessType==1 "  label="用户类型：">
            <el-select v-model="adConfig.userType" filterable placeholder="请选择/输入"  >
              <el-option
                  v-for="item in allUserTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item :label-width="labelWidth" v-if="adConfig.businessType!=3 "  label="位置编号："> 
          <el-input-number  :min="0" :max="100" tyle="width: 220px" type="text" v-model="adConfig.positionNumber"> </el-input-number> 
        </el-form-item> 
        <el-form-item width="100"  label="是否可用:">
          <el-switch v-model="adConfig.state"
                               :active-value="true"
                               :inactive-value="false"
                               active-text="是"
                               inactive-text="否" >
                    </el-switch>
        </el-form-item> 
        <el-form-item style="text-align-last: center;">
            <el-button plain size="middle" type="success" @click="saveOrUpdatePrize">确定</el-button>
            <el-button plain size="middle" type="info" @click="editDialogFun(false)">返回</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="messageDialog.title" center :visible.sync="messageDialog.show" width="30%">
      <h1 v-html="messageDialog.message"/>
      <el-button plain size="mini" type="success" @click="messageDialogFun(false)">确定</el-button>
    </el-dialog>
    <!-- 选品部分弹窗========================================================== -->
          <div>
            <el-dialog title="包含游戏"
                       center
                       :visible.sync="selectorDialogVisible"
                       @open="matchInfo"
                       @close="selectorDialogVisible=false"
                       :close-on-click-modal="false"
                       :show-close="false"
                       :destroy-on-close="true"
                       width="1500px">
                <div style="margin-bottom: 10px;">
                    <span>游戏名称：</span>
                    <el-select v-model="queryData.gameIds" multiple clearable filterable placeholder="请选择/输入">
                        <el-option
                            v-for="item in gameSelectorList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <!-- 默认查询业务为208 -->
                    <span >业务类型：</span>
                    <el-select v-model="queryData.dept" clearable  placeholder="请选择/输入">
                                <el-option
                                        v-for="item in deptConst"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                    </el-select>
                    <span > 游戏标签：</span>
                    <el-cascader v-model="queryData.gameLabels" :options="labelList" :props="{ key:'id',value:'id', label:'name',multiple:true }" clearable collapse-tags></el-cascader>
                    <br>
                    <el-button type="primary" @click="queryGameList">查询</el-button>
                    <table>
                        <tr>
                            <td>
                                <el-button  type="primary" @click="clearAllSelected">一键清除</el-button>
                            </td>
                            <!-- <td>
                                <el-upload :action="upload()" :headers="headers"
                                           :on-success="handleSuccess"
                                           :before-upload="beforeUpload"
                                           :show-file-list="false"
                                           v-loading.fullscreen.lock="loading" :disabled="disable"
                                           ref="upload">
                                    <el-button size="medium" type="primary" :disabled="disable">导入</el-button>
                                    <span style="color:crimson">当前只能导入一次， 导入成功后如需重新导入请关闭页面后，再重新打开。</span>
                                </el-upload>
                            </td> -->
                        </tr>
                    </table>
                </div>
                <template>
                    <h4>选择游戏（最少1个)</h4>
                    <el-table border
                              ref="multipleTable"
                              :data="gameList"
                              :row-class-name="gameRowTableClass"
                              stripe
                              tooltip-effect="dark"
                              style="width: 100%"
                              :row-key="getRowKeys"
                              @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                            type="selection"
                            :reserve-selection="true"
                            width="55">
                        </el-table-column>
                        <el-table-column
                            type="index"
                            label="编号"
                            width="50">
                        </el-table-column>
                         <el-table-column 
                            label="游戏id"
                            prop="gameId"
                            width="50">
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="游戏名称">
                        </el-table-column>
                        <el-table-column
                                prop="dept"
                                label="业务类型">
                        </el-table-column>
                        <el-table-column
                                    :formatter="formatGameLabels"
                                    :show-overflow-tooltip="true"
                                    prop="gameLabelNames"
                                    label="游戏标签">
                            </el-table-column>
                    </el-table>
                    <div>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="queryData.page"
                            :page-sizes="[  10,30,50,70,90,100]"
                            :page-size="queryData.size"
                            layout="total, sizes, prev, pager, next"
                            :total="totalElements">
                        </el-pagination>
                    </div>
                </template>
                <template v-if="selectedGameList.length>0">
                    <h4>已经选择的游戏</h4>
                    <el-table border
                              :data="selectedGameList"
                              tooltip-effect="dark"
                              style="width: 100%">
                        <el-table-column
                            type="index"
                            label="编号"
                            width="50">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="游戏名称">
                        </el-table-column>
                        <el-table-column
                                    :formatter="formatGameLabels"
                                    :show-overflow-tooltip="true"
                                    prop="gameLabelNames"
                                    label="游戏标签">
                            </el-table-column>
                        <el-table-column
                            label="操作"
                            align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="danger"
                                           @click.native.prevent="deleteRow(scope.$index, scope.row)">移除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <el-form>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirmAddSelect(selectedGameList,matchInfo().id)">确定</el-button>
                        <el-button type="info" @click="closeSelectorFormDialog()">返 回</el-button>
                    </div>
                </el-form>
            </el-dialog> 
        </div>
  </div>
</template>

<script>
import utils from '@/utils'
import {  
   allBusinessType,allUserType,allInnerPositionType,gameRunningList,listAdConfig,changeAdConfigState,searchAdMaterial,
   addAdConfig,editAdConfig,searchAdConfig,searchAdConfigSelector,adSearchGameList,adSelectorBatchAdd,allMyPositionType,allPartitionPositionType,channelList,allGameLabels} from "@/http/api";
// import store from '@/store';
export default {
  inject: ['reload'],
  name: "AdConfig",
  data() {
    return {
      
      labelWidth: '100px',
      editDialog: {
        show: false,
        title: null
      },
      allBusinessTypes: [ ], 
      allUserTypes: [ ], 
      allInnerPositionTypes: [ ],  
      allMyPositionTypes: [ ],  
      allPartitionPositionTypes: [ ],  
      channelList:[],
      subCategoryList:[],
      //全部可选活动type
      businessTypes:[],
      //当前选中活动type类型
      selectedBusinessTypes: 0,
      adConfig: {
        id: null,
        name: null,
        positionNumber:null,
        businessType: null,
        positionType: null,
        userType:null,
        state:null,
        subChannels:[],
        materialIds:[]
      },
      queryAdConfig:{
        userType: null,
        positionType: null,
        businessType:null,
        subChannels:null
      },
      //广告管理数据s
      adConfigs: null,
      //编辑标志位
      editFlag : false, 
      messageDialog: {
        show: false,
        title: null,
        message: null
      },
      //===========选品部分
      selectorDialogVisible: false,
      // 游戏选品
      queryData:{
        "gameLabels":[],
        "gameLabelId":[],
        "gameIds":[],
        "page": 1,
        "size": 10,
        "dept":''
      },
      //游戏选品总数
      totalElements: 0,
      //游戏选品中游戏列表下拉框数据 固定的
      gameSelectorList: [],
      //临时数组
      tempSelectedGameList:[],
      //已选游戏数组
      selectedGameList:[],
      //判断是否进行监听selectedGameList 标志位
      flag: false,
      //查询出的游戏list 待勾选游戏list
      gameList:[],
      //选中的某条广告配置数据
      rule: {},
      //上传文件加载中flag
      loading: false,
      //设置导入按钮是否可用 flag
      disable:false, 
      // 业务组常量 目前写死 
      deptConst:[{id:0,name:'全部',value:null},
          {id:1,name:'208',value:"208"},
          {id:2,name:'211',value:"211"}],
      optionProps: {
        emitPath: false,
        multiple: true,
        value: 'subChannel',
        label: 'name',
        children: 'children',
         },
        labelList:[],
        materials:[]
    }
  },
  created() {
     let _this = this;
    //获取全部任务list 
     //查询默认广告管理数据
     this.vueListAdConfig();
     allBusinessType().then(resp => {
       this.allBusinessTypes=resp.data.info
     }); 
     allUserType().then(resp => {
       this.allUserTypes=resp.data.info
     });
     allInnerPositionType().then(resp => {
       this.allInnerPositionTypes=resp.data.info
     });
     allMyPositionType().then(resp => {
       this.allMyPositionTypes=resp.data.info
     });
     allPartitionPositionType().then(resp => {
       this.allPartitionPositionTypes=resp.data.info
     });
      channelList().then(resp => {
          this.channelList = JSON.parse(JSON.stringify(resp.data.info)).map(channel => {
              if (channel.children) {
                  channel.children = channel.children.filter(sub => sub.state === 1)
              }
              return channel;
          }).filter(channel => channel.children && channel.children.length);
          this.channelList.forEach(function (channel) {
              _this.$set(channel, 'subChannel', channel.id);
          });
      });
     gameRunningList().then(resp => {
            this.gameSelectorList = resp.data.info;
        });
     // 获取游戏标签
            allGameLabels().then(resp=>{
                this.labelList=resp.data.info;
            })
  },
  mounted() {
    this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
    this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
  },
  watch: { 
        tempSelectedGameList: {
            handler(val, oldVal) {
                //console.log('tempSelectedGameList', val, oldVal)
                //如果是加载数据阶段设置勾选时 不进行监听直接返回
                if (!this.flag) return;
                //新增数据判断
                const isAdd = val.length > oldVal.length;
                const oldArr = [], arr = [];
                oldVal.forEach((item) => {
                    oldArr.push(item.gameId)
                });
                val.forEach((item) => {
                    arr.push(item.gameId)
                });
                //console.log('arr', oldArr, arr)
                if (isAdd) {
                    let result = [];
                    arr.forEach(gameId => {
                        //把新增的数据项push进结果中 result
                        if (oldArr.indexOf(gameId) === -1) {
                            result.push(gameId)
                        }
                    });
                    result.forEach(gameId => {
                        //新数据中如果 id为新增数据项已经初始化之后了ranklabel 则添加到selectedGameList最终结果中
                        val.forEach((item) => {
                            if (item.gameId === gameId) this.selectedGameList.push(item)
                        })
                    })
                } else {
                    //删除时
                    let result = [];
                    oldArr.forEach(gameId => {
                        //把删除的id找出来
                        if (arr.indexOf(gameId) === -1) {
                            result.push(gameId)
                        }
                    });
                    //把selectedGameList中对应resultId 删除
                    result.forEach(gameId => {
                        this.selectedGameList.forEach((item, index) => {
                            if (item.gameId === gameId) this.selectedGameList.splice(index, 1)
                        })
                    })
                }
            }
        },
    },
  methods: {
    formatDate: function(row, column, cellValue) {
                return utils.DateUtil.formatDate(cellValue, "yyyy-MM-DD HH:mm:ss")
     },
    formatGameLabels: function(row, column, cellValue) {
                var name="无";

                if(cellValue!=null && cellValue.length>0){
                   return  cellValue  ;
                } 
                return name;
            },
    businessTypeFormatter: function (row, column, cellValue){
      var temp="其他"
      this.allBusinessTypes.forEach( item => {
        if(item.id===cellValue){
               temp=item.name;
            } 
      })
      return temp
    },
    positionTypeFormatter: function (row, column, cellValue){
      var temp="其他"
      this.allInnerPositionTypes.forEach( item => {
        if(item.id===cellValue){
               temp=item.name;
            } 
      })
      return temp
    },
    positionTypePartitionFormatter: function (row, column, cellValue){
      var temp="其他"
      this.allPartitionPositionTypes.forEach( item => {
        if(item.id===cellValue){
               temp=item.name;
            } 
      })
      return temp
    },
    positionTypeMyFormatter: function (row, column, cellValue){
      var temp="其他"
      this.allMyPositionTypes.forEach( item => {
        if(item.id===cellValue){
               temp=item.name;
            } 
      })
      return temp
    },
    userTypeFormatter: function (row, column, cellValue){
      var temp="其他"
      this.allUserTypes.forEach( item => {
        if(item.id===cellValue){
               temp=item.name;
            } 
      })
      return temp
    },
    //获取默认广告配置list
     vueListAdConfig(){
        listAdConfig(this.selectedBusinessTypes).then(resp=>{
        this.adConfigs=resp.data.info 
            });
     },
     searchListAdConfig() {
           this.queryAdConfig.businessType=Number(this.selectedBusinessTypes)
            searchAdConfig(this.queryAdConfig).then(resp => {
                this.adConfigs = resp.data.info;
                //设置总条数
                // this.totalSize = resp.data.info.totalElements;
            })
        },
    saveOrUpdatePrize() {
      if(this.editFlag){
        editAdConfig(this.adConfig).then(resp => {
        if (resp.data.status === 0) {
          this.editDialogFun(false);  
          this.$message.success('修改成功');
          this.searchListAdConfig();  
        }else{
          this.$message.error('修改失败');
        }
      });
      }else{
          addAdConfig(this.adConfig).then(resp => {
        if (resp.data.status === 0) {
          this.editDialogFun(false);  
          this.$message.success('新增成功');
          this.searchListAdConfig();  
        }else{
          this.$message.error('新增失败');
        }
      });
      }  
    }, 
    update(row){
      // 修改开关更新方法 只需要传入id即可进行转换 
      changeAdConfigState(row.id).then(resp=>{
          if (resp.data.msg==='成功'){ 
                  //避免闪屏
                  // this.reload();  
          }else{
            //无法修改该属性 设置为相反值不进行 效果就是开关无法修改
            row.state=!row.state;
          }
      });
    },
    editDialogFun(show, title, data) {
      this.queryMaterials();
      this.editDialog.show = show;
      this.editDialog.title = title;
 
      this.editFlag=false;
      this.adConfig.id=null, 
      this.adConfig.name= null,
      this.adConfig.positionNumber=null,
      // 进行字符串转换为数字  否则下拉框不会展示label
      this.adConfig.businessType=  Number(this.selectedBusinessTypes),
      this.adConfig.positionType= null,
      this.adConfig.materialIds=[];
      this.adConfig.userType=null ,
      this.adConfig.state=false ;
      this.adConfig.subChannels=[] ;
      //设置活动类别后台设置即可
      this.adConfig.activityType=this.selectedBusinessTypes;

      if (show && data) {
      this.adConfig.id=data.id, 
      this.adConfig.name= data.name,
      this.adConfig.positionNumber=data.positionNumber,
      this.adConfig.positionType= data.positionType, 
      this.adConfig.userType=data.userType;
      this.adConfig.state=data.state;
      this.adConfig.materialIds=data.materialIds;
      this.adConfig.subChannels=data.subChannels ===null ?[]:data.subChannels.split(",") ;
        //设置编辑标志位
      this.editFlag=true;
      }
    },
    messageDialogFun(show, title, message) {
      this.messageDialog.show = show;
      this.messageDialog.title = title;
      this.messageDialog.message = message;
    }, 
    changeActivityTypeStyle(tab ) {
      // this.$store.commit('changeSelectedAdConfigType', tab.name); 
      this.selectedBusinessTypes=tab.name
      //刷新任务数据
      this.vueListAdConfig();
    }, 
    // =================================================== 选品部分方法
    gameRowTableClass({row, rowIndex}) {
            row.index = rowIndex
        },
    getRowKeys(row) {
                return row.gameId
            },
    matchInfo: function () {
            return this.rule;
        },
    queryGameList() { 
                //页数置1
                this.queryData.page = 1;
                this.gameSelectorTemp()
      },
      queryMaterials(){
        let queryData = {
          page :1,
          size :10000,
          id:null,
          state:1,
          materialPosition:parseInt(this.selectedBusinessTypes)
        };
        searchAdMaterial(queryData).then(resp=>{
            this.materials=resp.data.info.content;
        })
      },
      clearAllSelected() {
            //清除全部已选游戏
            //这个flag是设置watch监听事件 当跟新完当前页已选游戏标志位后再下一次渲染中设置为true
            // this.flag = false
            //重要 这里是element分页的一个bug 在分页情况下切换已勾选页会重复添加已勾选数据 所以在这里清除全部勾选
            // this.gameList.forEach(item => {
            //     this.$refs.multipleTable.toggleRowSelection(item,false);
            // })
            this.$refs.multipleTable.clearSelection();
            this.selectedGameList = [];
            this.tempSelectedGameList = [];
            this.disable=true;
            // this.flag=true;
        },
      gameSelectorTemp() {
            //这个flag是设置watch监听事件 当跟新完当前页已选游戏标志位后再下一次渲染中设置为true
            this.flag = false;
            //重要 这里是element分页的一个bug 在分页情况下切换已勾选页会重复添加已勾选数据 所以在这里清除全部勾选
            this.gameList.forEach(item => {
                this.$refs.multipleTable.toggleRowSelection(item, false);
            });
            let newLabelIds =[];// eslint-disable-line no-unused-vars
                 this.queryData.gameLabels.forEach(function (label) {
                      label.forEach(function (sub,index) {
                         if(index%2!==0){
                             newLabelIds.push(sub);
                         }
                      })
                 });
                 this.queryData.gameLabelIds=newLabelIds;
            adSearchGameList(this.queryData).then(resp => {
                this.gameList = resp.data.info.content;
                this.totalElements = resp.data.info.totalElements;
                //获取已选中游戏id
                const ids = [];
                this.selectedGameList.length && this.selectedGameList.forEach(item => {
                  //添加游戏id 而不是主键
                    ids.push(item.gameId)
                });
                //临时temp数组
                const tempSelectedGameList = [];
                //console.log('xxxx', ids)
                //判断当前页是否有已选中游戏 如果有设置已勾选
                ids.length && this.gameList.forEach(item => {
                  //这里使用的是游戏id 作为id字段 与之前ids有所区别
                    if (ids.indexOf(item.gameId) > -1) {
                        tempSelectedGameList.push(item);
                        this.$refs.multipleTable.toggleRowSelection(item, true);
                    }
                });
                this.disable=false;
                //console.log('new page: ', tempSelectedGameList)
                //赋值
                this.tempSelectedGameList = tempSelectedGameList;
                //渲染 并设置flag为true
                this.$nextTick(() => this.flag = true)
            });
        },
        closeSelectorFormDialog: function () {
            this.selectedGameList = [];
            this.tempSelectedGameList = [];
            this.selectorDialogVisible = false;
        },
        showSelectorDialog: function (row) {
            this.disable=false;
            this.selectorDialogVisible = true;
            this.rule = row;
            this.queryData = {
                 "gameLabels":[],
                 "gameLabelIds":[],
                  "gameIds":[],
                  "page": 1,
                  "size": 10,
                  "dept":"208"
            },
            //展示前清空临时已选游戏列表
            this.tempSelectedGameList = [];
            this.selectedGameList = [];
            //=========================================================初始化已选游戏列表
            //获取已选择的游戏信息 传入
            //console.log(this.rule.id);
            searchAdConfigSelector(this.rule.id).then(resp => {
                //设置临时已经选择的list
                if (resp.data.info) {
                  console.log(resp.data.info);
                    resp.data.info.forEach((info) => {
                        //这里查询获取到的已经选择游戏
                        this.selectedGameList.push(info)
                    });
                }
                //调用通用数据处理方法
                this.gameSelectorTemp();
            });
        },
        beforeUpload(data){
            console.log(data);
        },
        //导入游戏文件
        upload() {
            return this.VUE_APP_BASE_URL + '/gameMatch/selector/list/excel/'+this.rule.id;
        },
        handleSuccess(data){
            this.selectorDialogVisible=true;
            this.queryData = {
                 "gameLabels":[],
                 "gameLabelIds":[],
                  "gameIds":[],
                  "page": 1,
                  "size": 10,
                  "dept":''
            },
            //展示前清空临时已选游戏列表
            this.tempSelectedGameList=[];
            this.selectedGameList=[];
            //=========================================================初始化已选游戏列表
            //获取已选择的游戏信息 传入
            if (data.info){
                data.info.forEach((info)=>{
                    //这里查询获取到的已经选择游戏
                    this.selectedGameList.push(info)
                });
            }
            //调用通用数据处理方法
            this.gameSelectorTemp();
        },
        handleSelectionChange(val) {
            this.disable = true;
            let _this = this;
            //console.log('select', val)
            // val.forEach(function (game) {
            //     //设置默认值
            //     _this.selectedGameList.forEach(function (gameSelector) {
            //         if (game.id === gameSelector.gameId) {
            //             _this.$set(game, 'rank', gameSelector.rank);
            //             _this.$set(game, 'label', gameSelector.label)
            //             _this.$set(game, 'highLight', gameSelector.highLight)
            //         }
            //     })
            // });
            _this.tempSelectedGameList = val
        },
        handleSizeChange(newSize) {
            this.queryData.size = newSize;
            this.gameSelectorTemp()
        },
        handleCurrentChange(newPage) {
            this.queryData.page = newPage;
            this.gameSelectorTemp()
        },
        confirmAddSelect(preList,adId) {
            // console.log(preList)
            // console.log(adId)
            let _this = this;
            let gameSelectors = [];
            let obj = {};
            //构造新的游戏选品list 传给后台
            gameSelectors= preList.reduce((cur, next) => {
                        obj[next.gameId] ? "" : (obj[next.gameId] = true && cur.push(
                            { 
                              "gameId":next.gameId,
                              "adId":adId,
                                }));
                        return cur;
                    }, []); 
            //这里 改成传入  在后台进行已有数据清空
            adSelectorBatchAdd(gameSelectors).then(resp => {
                if (resp.data.status === 0) {
                    _this.searchListAdConfig();
                }
            }).catch(function () {
            });
            //调用关闭dialog接口
            this.closeSelectorFormDialog();
        },
        deleteRow(index, row) {
            this.disable=true
            this.selectedGameList.splice(index, 1);
            this.gameList.forEach(item => {
                if (item.gameId === row.gameId) {
                    this.$refs.multipleTable.toggleRowSelection(item, false);
                    this.tempSelectedGameList.forEach((game, index) => {
                        //如果删除的是临时的游戏选品 而不是已经选好的 需要清除对应templist
                        if (game.gameId === row.gameId) this.tempSelectedGameList.splice(index, 1)
                    })
                }
            })
        },

  }
}
</script>

<style lang="less">
.sub {
  position: relative;
  left: 570px
}


.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar1 {
  width: 150px;
  height: 200px;
  display: block;
}

.elalert {
  max-width: 89%;
  left: 11%;
}

.iconSize {
  font-size: 14px;
  font-weight: normal;
}

</style>
